<template>
  <v-card hover @click="$router.push('/fitness/' + date)" style="cursor: pointer;">
    <v-card-title>
      <i class="fad fa-shoe-prints" style="margin-right: 10px;"></i>
      {{ $t("fitness.header") }}
    </v-card-title>
    
    <div v-if="!loaded" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center;">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else-if="!fitnessData" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center; padding: 20px;">
      <p style="color: grey;">{{ $t("fitness.no_data_here") }}</p>
    </div>
    <div v-else>
      <v-card-text>
        <v-layout row wrap style="margin: 0;">
          <v-flex xs6 sm4 style="text-align: center; padding: 10px;">
            <i class="fad fa-shoe-prints fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ formattedSteps }}</div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("fitness.steps") }}</div>
          </v-flex>
          <v-flex xs6 sm4 style="text-align: center; padding: 10px;">
            <i class="fad fa-flame fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ formattedCalories }}</div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("fitness.calories") }}</div>
          </v-flex>
          <v-flex xs6 sm4 style="text-align: center; padding: 10px;">
            <i class="fad fa-map fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ formattedDistance }} <span style="font-size: 12px; font-weight: normal;">km</span></div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("fitness.distance") }}</div>
          </v-flex>
          <v-flex xs6 sm6 style="text-align: center; padding: 10px;" v-if="fitnessData && fitnessData.heart_rate">
            <i class="fad fa-heartbeat fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ Math.round(fitnessData.heart_rate) }} <span style="font-size: 12px; font-weight: normal;">bpm</span></div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("fitness.resting_heart_rate") }}</div>
          </v-flex>
          <v-flex xs6 sm6 style="text-align: center; padding: 10px;" v-if="fitnessData && fitnessData.sleep_duration">
            <i class="fad fa-moon fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ formattedSleep }}</div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("fitness.sleep_effective") }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { storage } from "../../schmucklicloud";
var numeral = require("numeral");

export default {
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      fitnessData: null
    };
  },
  computed: {
    formattedSteps() {
      if (!this.fitnessData) return "-";
      return numeral(this.fitnessData.steps).format("0,000").replace(/,/g, "'");
    },
    formattedCalories() {
      if (!this.fitnessData) return "-";
      return numeral(this.fitnessData.calories).format("0,000").replace(/,/g, "'");
    },
    formattedDistance() {
      if (!this.fitnessData) return "-";
      return numeral(this.fitnessData.distance).format("0.00").replace(/,/g, "'");
    },
    formattedSleep() {
      if (!this.fitnessData || !this.fitnessData.sleep_duration) return "-";
      var minutes = parseInt(this.fitnessData.sleep_duration);
      var hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return hours + "h " + minutes + "m";
    }
  },
  watch: {
    date() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loaded = false;
      this.fitnessData = null;
      
      var response = await storage.get("fitness_daily", [
        {
          column: "date",
          operator: "==",
          value: this.date,
        },
      ]);

      if (response.isOK && response.data && response.data.length > 0) {
        this.fitnessData = response.data[0].data;
      }
      this.loaded = true;
    }
  }
};
</script>

<style scoped>
</style>
